import find from "lodash/find";
import get from "lodash/get";
import map from "lodash/map";
import startsWith from "lodash/startsWith";
import isArray from "lodash/isArray";
import { getHeaders } from "../helpers/utils";
import api from "./ApiService";
import dayjs from "dayjs";

export const SEARCH_FIELDS = [
  {
    label: "Mot clé",
    value: "keyword",
    filterName: "Keyword",
  },
  {
    label: "Identifiant",
    value: "id",
    filterName: "EstateIds",
    isArray: true,
  },
  {
    label: "Zip",
    value: "zip",
    filterName: "ZipCodes",
    isArray: true,
  },
  {
    label: "Prix",
    value: "price",
    filterName: "PriceRange",
  },
];

const getEstates = async ({
  search,
  purpose,
  purposeStatus,
  categories,
  subCategories,
  representatives,
  offices,
  displayStatus,
  status,
  priceMin,
  priceMax,
  limit,
  page,
  ParentId,
  zipCodes,
  city,
  canHaveChildren,
  isTopParent,
}) => {
  const clearEmptyFilter = (obj) => {
    if (isArray(obj)) {
      return obj.filter(Boolean);
    }
    return obj;
  };

  let filter = {
    LanguageId: "fr-BE",
    WithRefDescriptions: true,
    ShowRelatedContacts: true,
    ShowRepresentatives: true,
    PurposeIds: clearEmptyFilter([purpose]),
    PurposeStatusIds: clearEmptyFilter(purposeStatus),
    CategoryIds: clearEmptyFilter(categories),
    SubCategoryIds: clearEmptyFilter(subCategories),
    RepresentativeIds: clearEmptyFilter(representatives),
    OfficeIds: clearEmptyFilter(offices),
    DisplayStatusIds: clearEmptyFilter(displayStatus),
    StatusIds: clearEmptyFilter([status]),
    ZipCodes: clearEmptyFilter(zipCodes),
    City: city,
    PriceRange: {},
    ParentId,
  };

  const searchValue = get(search, "value");
  if (!!searchValue) {
    const field = find(SEARCH_FIELDS, (item) => item.value === search.key);
    if (field) {
      if (field.value === "id") {
        filter.EstateIds = map([search?.value], (id) => {
          if (startsWith(id, "#")) {
            return parseInt(id.replace("#", ""));
          }
          return parseInt(id);
        });
      } else if (field.value === "price") {
        priceMin = searchValue;
        priceMax = searchValue;
      } else if (field.isArray) {
        filter[field.filterName] = clearEmptyFilter([searchValue]);
      } else {
        filter[field.filterName] = searchValue;
      }
    }
  }

  if (!!canHaveChildren) {
    filter.CanHaveChildren = true;
  }

  if (isTopParent != null) {
    filter.isTopParent = isTopParent;
  }

  if (priceMin > 0 || priceMax > 0) {
    filter.PriceRange.Min = parseInt(priceMin);
  }
  if (priceMax > 0) {
    filter.PriceRange.Max = parseInt(priceMax);
  }

  let payload = {
    Filter: filter,
    Page: {
      Offset: limit * (page - 1),
      Limit: limit,
    },
    Date: dayjs().format("YYYY-MM-DD"),
  };

  if (!limit || !page) delete payload.Page;

  const res = await api.post("Estate", payload, {
    headers: getHeaders(),
  });
  return res.data;
};

const getEstatesSuggestions = async ({
  filenames,
  officeIds,
  purposeIds,
  purposeStatusIds,
  displayStatusIds,
}) => {
  const res = await api.post(
    "Estate/Matching",
    {
      Filenames: filenames,
      OfficeIds: officeIds,
      PurposeIds: purposeIds,
      PurposeStatusIds: purposeStatusIds,
      DisplayStatusIds: displayStatusIds,
    },
    {
      headers: getHeaders(),
    }
  );
  return res.data;
};

const EstateService = {
  getEstates,
  getEstatesSuggestions,
};

export default EstateService;
